<template>
  <el-dialog
    title="授予"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="540px"
    key="1"
    :modal="false"
    :before-close="handleClose">
    <div>
      <el-form v-if="visible" :model="integralValidateForm" ref="integralValidateForm" label-width="100px">
        <el-form-item
          label="授予积分"
          prop="integral"
          :rules="[
            { required: true, message: '积分不能为空'},
            { pattern: /^[+]{0,1}(\d+)$/, message: '请输入不小于0的整数', trigger: 'blur' },
            { validator: validatorIntagel, trigger: 'blur' },
          ]"
        >
          <el-input type="text" v-model="integralValidateForm.integral" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="授予理由" prop="reason"
          :rules="[
            { required: true, message: '授予理由不能为空'},
            { min: 1, max: 20, message: '授予理由长度不能超过20', trigger: 'blur' }
          ]"
        >
          <el-input type="text" v-model.trim="integralValidateForm.reason" autocomplete="off"></el-input>
        </el-form-item>
       <el-form-item label="操作站点" prop="siteId"
          :rules="[{ required: true, message: '操作站点不能为空'},]"
        >
          <el-cascader
            class="search-ascader"
            v-model="integralValidateForm.siteId"
              :options="siteOptions"
              :props="props"
               placeholder="请选择"
              clearable></el-cascader>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm('integralValidateForm')">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: '',
  props: ['visible', 'integralValidateForm'],
  data() {
    return {
      props: { children: 'childList', label: 'name', value: 'id', emitPath: false, expandTrigger: 'hover' },
      siteOptions: []
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.orgTreeList()
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('handleClose')
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit('submitForm', this.integralValidateForm)
          this.$emit('handleClose')
        } else {
          return false
        }
      })
    },
    validatorIntagel(rule, value, callback) {
      if (this.integralValidateForm.integral < 0) {
        return callback(new Error('积分不能为负数'))
      }
      if (this.integralValidateForm.integral > 999999) {
        return callback(new Error('积分不能大于999999'))
      }
      return callback()
    },
    // 站点
    orgTreeList() {
      this.$api.siteManage.org.orgTreeList().then(res => {
        this.$wtUtil.setSiteLevelKey(res.data)
        this.siteOptions = res.data
      })
    }
  }
}
</script>

<style>
</style>
